import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import {
  ReferenceValueSheet,
  ReferenceValueSheetDataSeries,
  ReferenceValueSheetKPIResults,
} from '../models/reference-value-sheet.model';

/*** Clear State. ***/
export const clearRefValSheetState = createAction('[ReferenceValueSheet] Clear RefValSheet State');

/*** Load Data. ***/
export const loadRefValSheetData = createAction('[ReferenceValueSheet] Load RefValSheet data');
export const loadRefValSheetsRequest = createAction(
  '[ReferenceValueSheet] Load RefValSheets request',
);
export const loadRefValSheetsSuccess = createAction(
  '[ReferenceValueSheet] Load RefValSheets success',
  props<{ refValSheets: ReferenceValueSheet[] }>(),
);
export const loadRefValSheetKPIsRequest = createAction(
  '[ReferenceValueSheet] Load RefValSheet KPIs request',
  props<{ ids: number[] }>(),
);
export const loadRefValSheetKPIsSuccess = createAction(
  '[ReferenceValueSheet] Load RefValSheet KPIs success',
  props<{ refValSheetKPIResults: ReferenceValueSheetKPIResults[] }>(),
);
export const loadRefValSheetsError = createAction(
  '[ReferenceValueSheet] Load RefValSheets error',
  props<{ error: HttpErrorResponse }>(),
);
export const loadColumnSettings = createAction('[ReferenceValueSheet] Load Column Settings');

/*** Upsert Actions. ***/
export const upsertRefValSheetRequest = createAction(
  '[ReferenceValueSheet] Upsert RefValSheet request',
  props<{ refValSheet: ReferenceValueSheet }>(),
);
export const copyRefValSheetAsNewRequest = createAction(
  '[ReferenceValueSheet] Copy RefValSheet as new request',
  props<{ refValSheet: ReferenceValueSheet }>(),
);
export const upsertRefValSheetSuccess = createAction(
  '[ReferenceValueSheet] Upsert RefValSheet success',
  props<{ refValSheet: ReferenceValueSheet }>(),
);
export const upsertRefValSheetError = createAction(
  '[ReferenceValueSheet] Upsert RefValSheet error',
  props<{ error: HttpErrorResponse }>(),
);

export const setColumnSettings = createAction(
  '[ReferenceValueSheet] Set Columns Settings',
  props<{ value: string[]; save: boolean }>(),
);

export const loadRefValSheetDataSeriesRequest = createAction(
  '[WithinCyclePerformance] Load RefValSheets DataSeries request',
  props<{ ids: number[] }>(),
);

export const loadRefValSheetDataSeriesSuccess = createAction(
  '[ReferenceValueSheet] Load RefValSheet DataSeries success',
  props<{ refValSheetDataSeries: ReferenceValueSheetDataSeries[] }>(),
);

export const loadRefValSheetDataSeriesError = createAction(
  '[ReferenceValueSheet] Load RefValSheet DataSeries failed',
  props<{ error: Error }>(),
);

/*** Navigation Actions. ***/
export const createRefValSheetNavigation = createAction(
  '[ReferenceValueSheet] Create RefValSheet Navigation',
);
export const editRefValSheetNavigation = createAction(
  '[ReferenceValueSheet] Edit RefValSheet Navigation',
  props<{ refValSheet: ReferenceValueSheet }>(),
);
export const viewRefValSheetNavigation = createAction(
  '[ReferenceValueSheet] View RefValSheet Navigation',
  props<{ refValSheet: ReferenceValueSheet }>(),
);

/*** DELETE ***/
export const deleteRefValSheetConfirm = createAction(
  '[ReferenceValueSheet] Delete RefValSheet confirm',
  props<{ refValSheet: ReferenceValueSheet }>(),
);
export const deleteRefValSheetRequest = createAction(
  '[ReferenceValueSheet] Delete RefValSheet request',
  props<{ refValSheetId: number }>(),
);
export const deleteRefValSheetSuccess = createAction(
  '[ReferenceValueSheet] Delete RefValSheet success',
  props<{ refValSheetId: number }>(),
);
export const deleteRefValSheetError = createAction(
  '[ReferenceValueSheet] Delete RefValSheet error',
  props<{ error: HttpErrorResponse }>(),
);
